<info-modal [title]="title" (onOk)="ok()">
	<ngb-pagination
			*ngIf="details && details.length > 0"
			[collectionSize]="totalCount / 50" 
			[maxSize]="10" 
			[pageSize]="1" 
			[(page)]="currentPage" 
			[boundaryLinks]="true" 
			(pageChange)="onPageChange()"
	></ngb-pagination>

	<br>
	<div class="col-md-12" *ngIf="details && details.length > 0">
		<span class="button-download-link" (click)="downloadButton()">
			<i class="fa fa-download" aria-hidden="true"></i>
			{{ 'adminstat.mails.mailer.export csv' | translate }}
		</span>
	</div>
	<br>
	
	<loading [isLoad]="!details || detailLoader"></loading>

	<table *ngIf="details && details.length > 0" class="table">
		<thead>
			<th>{{ 'adminstat.common.date_create' | translate }}</th>
			<th>{{ 'adminstat.common.Site' | translate }}</th>
			<th>{{ 'adminstat.support.accessor.Category' | translate }}</th>
			<th>{{ 'adminstat.support.accessor.Subject' | translate }}</th>
			<th>{{ 'adminstat.common.User' | translate }}</th>
		</thead>
	
		<tbody>
			<tr *ngFor="let stat of details">
				<td>
					{{ stat.dateCreate }}
				</td>
		
				<td>
					<site_info [siteUrl]="stat.domainUrl"></site_info>
				</td>
		
				<td>
					{{ stat.category }}
				</td>
		
				<td>
					{{ stat.subject }}
				</td>
		
				<td>
					{{ stat.user }}
				</td>
			</tr>
		</tbody>
	</table>
</info-modal>
